import { SortingKindEnum } from '../../utils/interfaces';
import { Order } from '../../utils/apollo/graphqlSchema';

export default (array: any, kind: SortingKindEnum, type: Order) => {
  if (!array) {
    return [];
  }
  return array.sort((a: any, b: any) => {
    if (kind === SortingKindEnum.DATE) {
      a = new Date(a.start);
      b = new Date(b.start);
    } else if (kind === SortingKindEnum.NAME) {
      if (a.version?.name && b.version?.name) {
        a = a.version.name.toLowerCase();
        b = b.version.name.toLowerCase();
      } else {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
      }
    } else if (kind === SortingKindEnum.TYPE) {
      a = a.type.name.toLowerCase();
      b = b.type.name.toLowerCase();
    } else if (kind === SortingKindEnum.KEY) {
      a = a.key.toLowerCase();
      b = b.key.toLowerCase();
    } else if (kind.toUpperCase() === SortingKindEnum.CREATION_DATE) {
      // special case for measures, where createdAt & creator are
      // within version.
      if (a.version?.createdAt && b.version?.createdAt) {
        a = new Date(a.version.createdAt);
        b = new Date(b.version.createdAt);
      } else {
        a = new Date(a.createdAt);
        b = new Date(b.createdAt);
      }
    } else if (kind.toUpperCase() === SortingKindEnum.EDIT_DATE) {
      if (a?.version?.editedAt && b?.version?.editedAt) {
        a = new Date(a.version.editedAt);
        b = new Date(b.version.editedAt);
      } else {
        a = new Date(a.editedAt);
        b = new Date(b.editedAt);
      }
    } else if (kind.toUpperCase() === SortingKindEnum.CREATOR) {
      if (a?.version?.creator && b?.version?.creator) {
        a = a.version.creator.name.toLowerCase();
        b = b.version.creator.name.toLowerCase();
      } else {
        a = a?.creator?.name?.toLowerCase();
        b = b?.creator?.name?.toLowerCase();
      }
    } else if (kind.toUpperCase() === SortingKindEnum.EDITOR) {
      if (a?.version?.editor && b?.version?.editor) {
        a = a.version.editor.name.toLowerCase();
        b = b.version.editor.name.toLowerCase();
      } else {
        a = a?.editor?.name?.toLowerCase();
        b = b?.editor?.name?.toLowerCase();
      }
    } else if (kind === SortingKindEnum.ALERTONLY) {
      a = a.alertOnly;
      b = b.alertOnly;
    } else if (kind === SortingKindEnum.LAST_LOGIN) {
      a = a.lastLogin;
      b = b.lastLogin;
    } else if (kind === SortingKindEnum.EMAIL) {
      a = a.email.toLowerCase();
      b = b.email.toLowerCase();
    } else if (kind === SortingKindEnum.KIND) {
      a = a.kind.toLowerCase();
      b = b.kind.toLowerCase();
    } else if (kind === SortingKindEnum.TAGS) {
      const aCategories = a.entityCategories ?? a.categories;
      const bCategories = b.entityCategories ?? b.categories;

      if (aCategories.length) {
        a = aCategories[0].name.toLowerCase();
      }

      if (bCategories.length) {
        b = bCategories[0].name.toLowerCase();
      }
    } else if (kind === SortingKindEnum.FAVORITE) {
      a = a.isFavorite ? 1 : 0;
      b = b.isFavorite ? 1 : 0;
    } else if (kind === SortingKindEnum.DESCRIPTION) {
      // Handle different types of structures for description
      a =
        a.description?.toLowerCase() ??
        a.version?.description?.toLowerCase() ??
        '';
      b =
        b.description?.toLowerCase() ??
        b.version?.description?.toLowerCase() ??
        '';
    }

    switch (type) {
      case Order.Desc:
        return a > b ? -1 : a < b ? 1 : 0;
      case Order.Asc:
        return a < b ? -1 : a > b ? 1 : 0;
      default:
        return 0;
    }
  });
};
